import Vue from 'vue'
import Vuex from 'vuex'
import controls from './controlStore';

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    controls,
  },
  state: {
    config: {},
    id: '',
    time: -1,
    duration: 0,
    dataset: {},
    interactiveItems: [],
    slides: [],
    video: null,
    activeVideo: null,
    disabledPostermode: false,
    activeMode: 'PIP',
    theaterMode: false,
    smallDevice: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    scrubDragging: false,
    currentPopup: '',
  },
  mutations: {
    changeConfig(state, config) {
      state.config = {
        hiddenControls: {},
        ... config
      }
    },
    setMute(state, value) {
      state.config.mute = value
    },
    changeId(state, id) {
      state.id = id
    },
    changeTime(state, time) {
      state.time = time
    },
    setDuration(state, duration) {
      state.duration = duration
    },
    changeDataset(state, dataset) {
      state.dataset = dataset
    },
    setToken(state, token) {
      state.config.token = token;
    },
    setInteractiveItems(state, payload) {
      state.interactiveItems = payload
    },
    setSlides(state, payload) {
      state.slides = payload
    },
    setVideo(state, payload) {
      state.video = payload
      state.activeVideo = payload
    },
    disablePosterMode(state) {
      state.disabledPostermode = true
    },
    setActiveMode(state, payload) {
      state.activeMode = payload;
    },
    setTheaterMode(state, payload) {
      state.theaterMode = payload;
    },
    toggleTheaterMode(state) {
      if (state.theaterMode === 'on') {
        state.theaterMode = 'off';
      } else if (state.theaterMode === 'off') {
        state.theaterMode = 'on';
      }
    },
    closeTheaterMode(state) {
      if (state.theaterMode !== false) {
        state.theaterMode = 'off';
      }
    },
    updateScrubDragging(state, value) {
      state.scrubDragging = value
    },
    setCurrentPopup(state, payload) {
      state.currentPopup = payload
    }
  },
  getters: {
    isPostermode: state => state.config.postermode && !state.disabledPostermode,
    isGoogleAnalyticsEnabled: state => typeof state.config.gaId !== 'undefined',
    isAdobeAnalyticsEnabled: state => typeof state.config.adobeTrackingDomain !== 'undefined',
    isAdobeAnalyticsByURLEnabled: state => typeof state.config.adobeTrackingScriptUrl !== 'undefined',
    isInteractive: state => state.interactiveItems.length > 0 && !state.config.disableInteractive,
    hasInteractiveControls: state => state.interactiveItems.length > 0 && state.dataset.controlsInteractive + '' !== 'false',
    hasSlides: state => state.slides.length > 0 && !state.config.disablePresentation,
    interactiveShowScrub: state => state.config.interactiveShowScrub,
    interactiveShowTimestamp: state => state.config.interactiveShowTimestamp,
    interactiveFullscreenButtonPosition: state => state.config.interactiveFullscreenButtonPosition,
    isAudioOnly: state => state.config.audioOnly,
    hideChapters: state => state.config.showChapters === false || state.config.hideControls['chapters'] || state.config.hiddenControls['chapters'],
    externalFullscreen: state => state.config.externalFullscreen,
    hideFullscreen: state => state.config.allowFullscreen === false,
    canShowControl: state => (attribute) => {
      let control = [];
      Object.keys(state.config.hiddenControls).forEach(key => {
        if (state.config.hiddenControls[key] === true) {
          control[key] = true;
        }
      });
      Object.keys(state.config.hideControls).forEach(key => {
        if (state.config.hideControls[key] === true) {
          control[key] = true;
        }
      });
      return control[attribute] !== true;
    },
    autoplay: state => {
      switch (state.config.autoplay) {
        case "viewable":
          return "muted";
        case "true":
          return true;
        case false:
        default:
          return false;
      }
    },
    aspectRatio: state => {
      let aspectRatio;
      if (state.config.aspectratio) {
        aspectRatio = state.config.aspectratio
      }
      if (!state.config.height) {
        aspectRatio = typeof aspectRatio !== 'undefined' ? aspectRatio : '16:9'
      }
      if (state.config.audioOnly) {
        aspectRatio = '16:9';
      }
      const split = aspectRatio.split(':');
      return {
        horizontal: split[0],
        vertical: split[1],
      }
    }
  }
})
